
import Vue from 'vue'
import MobileHeaderSubmenu from '../mobile-header-submenu/index.vue'

export default Vue.extend({
  components: {
    MobileHeaderSubmenu
  },
  inject: ['provider'],
  props: {
    sections: {
      type: Array<{
        code: string,
        title: string,
        children: Array<any>
      }>,
      required: true,
      default: () => { return [] }
    }
  },
  computed: {
    visibleMobileMenuCode () {
      return this.provider?.visibleMobileMenuCode
    }
  },
  methods: {
    openMenu (code: string) {
      this.$emit('openMenu', code)
    },
    closeMenu () {
      this.$emit('closeMenu')
    }
  }
})
